import { tenantStage, type PlatformTenantRow } from '@icetus/contracts';

/**
 * 平台总览的筛选语义。
 *
 * 从页面里抽出来单独放，只为了能被单测覆盖：筛选判据很容易写错，
 * 而且错了**不会报错**——「需要跟进」点开是空表，看的人只会以为
 * "今天没什么要跟进的"。
 */

export const PLATFORM_FILTERS = [
  { key: 'all', label: '全部' },
  { key: 'attention', label: '需要跟进' },
  { key: 'trialing', label: '试用中' },
  { key: 'paying', label: '付费中' },
  { key: 'none', label: '无订阅' },
] as const;

export type PlatformFilter = (typeof PLATFORM_FILTERS)[number]['key'];

/**
 * 一行是否命中筛选。
 *
 * 关键词匹配租户名 / 站点标识 / 所有者邮箱三处：超管找人时手上
 * 往往只有一个邮箱（财务给的付款方）或者一个站点标识（客服工单里写的）。
 */
export function matchesPlatformFilter(
  row: PlatformTenantRow,
  filter: PlatformFilter,
  keyword: string,
  now: Date = new Date(),
): boolean {
  const view = tenantStage(row, now);

  switch (filter) {
    case 'attention':
      if (!view.needsAttention) return false;
      break;
    case 'trialing':
      if (view.stage !== 'trialing') return false;
      break;
    case 'paying':
      if (view.stage !== 'active') return false;
      break;
    case 'none':
      if (view.stage !== 'no_subscription') return false;
      break;
    case 'all':
      break;
  }

  const needle = keyword.trim().toLowerCase();
  if (!needle) return true;
  const haystack = `${row.name} ${row.slug} ${row.ownerEmail ?? ''}`.toLowerCase();
  return haystack.includes(needle);
}
